import { asyncAction } from 'lib/actionCreators'

export const addSocialLinks = asyncAction('profile/ADD_SOCIAL_LINKS')
